import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'animate.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Web Vitals reporting — logs to console in dev, extend to analytics in prod
if (process.env.NODE_ENV === 'production') {
  reportWebVitals(({ name, value }) => {
    console.info(`[Web Vitals] ${name}: ${Math.round(value)}ms`);
    // TODO: replace with analytics.track() or sendBeacon() to your endpoint
  });
} else {
  reportWebVitals(console.log);
}
